<template>
  <div class="table-layout">
    <slot name="header">
      <table-header v-if="showHeader" :title="title" :description="description" />
    </slot>

    <div v-if="hasControls" class="table_controls_and_data" :class="{ 'with-search': $slots['controls-center'] }">
      <div class="table-layout__controls-left">
        <slot name="controls-left" />
      </div>
      <div class="table-layout__controls-center">
        <slot name="controls-center" />
      </div>
      <div class="table-layout__controls-right">
        <slot name="controls-right" />
      </div>
    </div>

    <slot name="filters" />

    <div v-if="wrapTable" class="table-container table-layout__table-container" :style="tableContainerStyle">
      <slot />
    </div>

    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'TableLayout',
  props: {
    title: {
      type: String,
      default: undefined
    },
    description: {
      type: String,
      default: ''
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    wrapTable: {
      type: Boolean,
      default: true
    },
    tableContainerStyle: {
      type: Object,
      default: () => ({
        flex: 1,
        overflow: 'hidden'
      })
    }
  },
  computed: {
    hasControls() {
      return Boolean(this.$slots['controls-left'] || this.$slots['controls-right'] || this.$slots['controls-center'])
    }
  }
}
</script>

<style scoped>
.table-layout {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-layout__controls-left,
.table-layout__controls-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.table_controls_and_data.with-search .table-layout__controls-center,
.table_controls_and_data.with-search .table-layout__controls-center ::v-deep .table-search-filters {
  display: contents;
}

.table_controls_and_data.with-search .table-layout__controls-center ::v-deep .table-search-filters__anchor {
  flex: 0 1 500px;
  min-width: 0;
  margin-left: auto;
}

.table_controls_and_data.with-search .table-layout__controls-center ::v-deep .table-search-filters__applied {
  flex: 0 0 100%;
  order: 1;
  padding: 0;
}

.table_controls_and_data.with-search .table-layout__controls-right {
  margin-left: 0;
}

.table-layout__controls-right {
  margin-left: auto;
}

.table-layout__table-container {
  min-height: 0;
}
</style>
